module.exports = __webpack_public_path__ + "img/trx.8e0092b5.png";